export default {
  title: 'Kostattributter',
};
